import { createAliasResolver, type InferSubjects } from '@casl/ability';

type CRUD = 'manage' | READ | 'create' | 'update' | 'delete';
type READ = 'read' | 'view' | 'query' | 'get' | 'list';
export type RosAbilities =
  | ['manage', 'all']
  | ['manage', 'Newsletter']
  | ['ros', 'Phone']
  | [
      'ros',
      (
        | 'Dashboard'
        | 'VehiclePool'
        | 'Bookings'
        | 'CreateBooking'
        | 'YieldManagement'
        | 'QueueInspector'
        | 'ListManualInvoiceBooking'
        | 'Receivables'
      ),
    ]
  | [CRUD | 'comment', 'Invoice' | 'Lead' | 'BankStatementEntry']
  | [
      CRUD,
      (
        | 'Car'
        | 'VehicleType'
        | 'User'
        | 'PartnerSubType'
        | 'Invoice'
        | 'PaymentTerminal'
        | 'Coupon'
        | 'ShortTermPricing'
        | 'LongTermPricing'
        | 'PricingModifier'
        | 'VehicleExtra'
        | 'ApiKey'
        | 'Allocation'
        | 'News'
        | 'InsuranceCase'
        | 'Station'
        | 'LegalEntity'
        | 'YieldManagementSettings'
        | 'Video'
        | 'Media'
        | 'RotationMedia'
        | 'GlobalSettings'
        | 'LedgerEntry'
        | 'Review'
        | 'WorkshopAppointment'
        | 'Infringement'
        | 'Lead'
        | 'BankStatementEntry'
      ),
    ]
  | [READ, 'AuditLog']
  | ['readCurrent', 'RotationMedia']
  | [CRUD | 'handle' | 'sendMails' | 'charge' | 'writeOff', 'Booking']
  | ['view' | 'process', 'ApprovalRequest']
  | ['reload', 'FeatureFlags']
  | [CRUD | 'refund', 'Payment']
  | ['crossAllocate' | 'refund', 'LedgerEntry']
  | ['readSummary', 'EmployeeDashboard']
  | ['program', 'RentalKeyTag'];

export const aliasResolver = createAliasResolver({
  read: ['view', 'query'],
  query: ['get', 'list'],
});
